<label class="toggle-field">
  <span class="toggle-label">{{ props['label'] }}</span>
  <span class="toggle-switch">
    <input
      type="checkbox"
      [formControl]="formControl"
      [formlyAttributes]="field"
      class="toggle-input"
      [attr.data-testid]="props['attributes']?.['data-testid']"
    />
    <span class="toggle-track">
      <span class="toggle-knob"></span>
    </span>
  </span>
</label>
@if (props['description']) {
  <p class="toggle-description">{{ props['description'] }}</p>
}
